// /src/components/Noticias.tsx
import React from "react";
import { noticias, NoticiaItem } from "../constants/noticias";

const Noticias: React.FC = () => {
  const handleNoticiaClick = (noticia: NoticiaItem) => {
    if (noticia.url) {
      window.open(noticia.url, "_blank", "noopener noreferrer");
    }
  };

  return (
    <div className="noticias">
      {noticias.map((noticia, index) => (
        <div
          key={index}
          className="noticias__item"
          onClick={() => handleNoticiaClick(noticia)}
        >
          {noticia.icon && <div className="noticias__icon">{noticia.icon}</div>}

          <div className="noticias__content">
            <div className="noticias__title">{noticia.title}</div>
            <div className="noticias__description">{noticia.description}</div>
          </div>

          {noticia.url ? (
            <a
              href={noticia.url}
              target="_blank"
              rel="noopener noreferrer"
              className="noticias__link"
            >
              <div className="noticias__arrow">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
                </svg>
              </div>
            </a>
          ) : null}
        </div>
      ))}

      {noticias.length === 0 && (
        <div className="noticias__empty">No hay noticias disponibles</div>
      )}
    </div>
  );
};

export default Noticias;
